export class ObjectHelper {
	public stringProp(o, s) {
		if (typeof o === 'undefined') return false;

		s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
		s = s.replace(/^\./, ''); // strip a leading dot
		var a = s.split('.');
		while (a.length) {
			var n = a.shift();
			if (!o) return null;

			if (n in o) {
				o = o[n];
			} else {
				return;
			}
		}
		return o;
	}

	/*
	 * Recursively merge properties of two objects
	 */
	public merge(obj1, obj2) {
		for (var p in obj2) {
			try {
				// Property in destination object set; update its value.
				if (obj2[p].constructor == Object) {
					obj1[p] = this.merge(obj1[p], obj2[p]);
				} else {
					obj1[p] = obj2[p];
				}
				// biome-ignore lint/correctness/noUnusedVariables: suppressed due to migration - should be fixed
			} catch (e) {
				// Property in destination object not set; create it and set its value.
				obj1[p] = obj2[p];
			}
		}

		return obj1;
	}
	/*
	 * Recursively merge properties of two objects
	 */
	public clone(obj) {
		var copy;

		// Handle the 3 simple types, and null or undefined
		if (null == obj || 'object' != typeof obj) return obj;

		// Handle Date
		if (obj instanceof Date) {
			copy = new Date();
			copy.setTime(obj.getTime());
			return copy;
		}

		// Handle Array
		if (obj instanceof Array) {
			copy = [];
			for (var i = 0, len = obj.length; i < len; i++) {
				copy[i] = this.clone(obj[i]);
			}
			return copy;
		}

		// Handle Object
		if (obj instanceof Object) {
			copy = {};
			for (var attr in obj) {
				if (Object.hasOwn(obj, attr)) copy[attr] = this.clone(obj[attr]);
			}
			return copy;
		}

		throw new Error("Unable to copy obj! Its type isn't supported.");
	}
}
